/**
 * Кастомная иконка «Глобус» (filled)
 *
 * Залитый глобус с меридианами — 6 сегментов
 * fill="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function GlobeIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9999 3.25049C10.9368 3.25049 9.41927 6.32505 9.26709 11.2047H14.7328C14.5807 6.32505 13.0631 3.25049 11.9999 3.25049Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.26709 12.7954C9.41927 17.675 10.9368 20.7496 12 20.7496C13.0631 20.7496 14.5807 17.675 14.7329 12.7954H9.26709Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3187 11.2046H22.0001C21.6239 6.41299 17.8997 2.55679 13.1758 2C15.1256 3.14434 16.1961 7.10236 16.3187 11.2046Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68139 11.2046C7.80398 7.10236 8.87452 3.14434 10.8244 2C6.10041 2.55679 2.37622 6.41299 2 11.2046H7.68139Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3187 12.7954C16.1961 16.8977 15.1256 20.8557 13.1758 22C17.8997 21.4432 21.6239 17.587 22.0001 12.7954H16.3187Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68139 12.7954H2C2.37622 17.587 6.10041 21.4432 10.8244 22C8.87452 20.8557 7.80398 16.8977 7.68139 12.7954Z"
        fill="currentColor"
      />
    </svg>
  );
}